export default {
    person: {
        wzTZ: 'King Honor 백스테이지 관리 시스템 알림 발표',
        wzKF: '개발자 연락처 정보',
        QQ1: 'QQ 번호 1',
        QQ2: 'QQ 번호 2',
        mailbox: '우체통',
        browser: '브라우저',
        RecommendedUse: '권장 사용법',
        mattersNeedingAttention: '노트',
        mattersNeedingAttention1: '원본을 수정하여 상업적 목적으로 사용하는 것은 금지되어 있습니다',
        mattersNeedingAttention2: '이 페이지는 개발자가 의사 소통하고 학습하기 위한 것입니다',
        version: '버전 번호',
    },
    home:{
        wzry:"로그인",
        game:'로그인',
        account:'계좌 번호를 입력해 주세요',
        password:'비밀번호를 입력해 주세요',
        remember:'암호를 기억하십시오'
    },
    Login:{
        name:"환영",
        register:"등록",
        logon:"로그인",
        ZY:"단풍은 약간 시원하고 어둡습니다",
        ReSelect:"다시"
    }
};